import useSupportStore from "../../../store/supportStore";
import { formatDateT } from "../../../../../shared/utils/formatters";
import { formatData } from "../../../utils/supportFormatters";

const stepKey = "spUse";

const SpUseMapper = {
  get: () => {
    const store = useSupportStore.getState();
    return store[stepKey] || {};
  },
  set: (data) => {
    const store = useSupportStore.getState();
    store.updateStepFields(stepKey, data);

    const details = {
      "What is your new use": data.hireType?.label,
      "Has the use been updated with your licencing authority, and have you obtained your new taxi badge? If no, you must change this with the licencing authority.":
        data.useUpdated,
      "Will your vehicle continue to be licenced by the existing licencing authority disclosed on your policy? If no, please provide the new licencing authority details.":
        data.licensingContinued,
      ...(data.licensingContinued === "No" && {
        "What will be the licencing authority?": data.LicenseAuth?.label,
      }),
    };

    const currentChanges = store.Payload.Changes;
    store.updateField("Changes", {
      ...currentChanges,
      Use: {
        Details: details,
        effectiveFrom: formatDateT(data.useEffectiveDateTime) || "",
        Requested: true,
      },
    });
  },
};

export default SpUseMapper;
